export default {
  "b2b.zadost-editace-widget.title": "Žádost {id}",
  "b2b.zadost-editace-widget.form.field.zakaznik": "Zákazník",
  "b2b.zadost-editace-widget.form.field.uzivatel": "Uživatel",
  "b2b.zadost-editace-widget.form.field.projekt": "Projekt",
  "b2b.zadost-editace-widget.form.field.fixni": "Fixní",
  "b2b.zadost-editace-widget.form.field.produkt": "Produkt",
  "b2b.zadost-editace-widget.form.field.zdroj": "Zdroj",
  "b2b.zadost-editace-widget.form.field.termin": "Termín",
  "b2b.zadost-editace-widget.form.field.doplnkove-sluzby": "Doplňkové služby",
  "b2b.zadost-editace-widget.form.field.poznamka-zakaznika":
    "Poznámka zákazníka",
  "b2b.zadost-editace-widget.form.field.poznamka-strojvedouci":
    "Poznámka strojvedoucí",
  "b2b.zadost-editace-widget.form.field.poznamka-spravce": "Poznámka správce",
  "b2b.zadost-editace-widget.form.field.historie": "Historie",
  "b2b.zadost-editace-widget.form.button.submit": "Uložit poznámky",
  "b2b.zadost-editace-widget.save-dialog.title": "Uložení poznámek žádosti",
  "b2b.zadost-editace-widget.title-description.label": "Vytvořeno"
};
